import { BADGE_POSITIONS, withBadge, withTooltip, IconNotification } from 'cdk-radial';
import { useTranslation } from 'react-i18next';
import * as Styles from './styles';
import { generateTooltipProps } from './Header';
import { useNotificationStore } from '../notification/NotificationStore';
import { useEffect, useRef, useState } from 'react';

const IconNotificationButton = (props: {
  onClick: Function
}) => {
  const { t } = useTranslation();
  const [isAnimating, setIsAnimating] = useState(false);

  const HeaderNotificationIcon = withTooltip(Styles.AnimationButton, generateTooltipProps('Notifications', t('notification.toolTip')))
  const unreadCount = useNotificationStore((state: any) => state.unreadCount);
  let count = useNotificationStore((state: any) => state.count);
  const previousCountRef = useRef(count);

  const setshouldNotificationRefresh = useNotificationStore((state: any) => state.setshouldNotificationRefresh);

  const onClickHandler = (event: any) => {
    setshouldNotificationRefresh(true);
    props.onClick(event);
  }

  useEffect(() => {
    if (count > previousCountRef.current) {
      setIsAnimating(true);
    }
    previousCountRef.current = count;
  }, [count]);

  const IconButtonComponent = () => {
    return (<HeaderNotificationIcon
      onClick={onClickHandler}
      backgroundAppearance={'dark'}
      icon={<IconNotification />}
      text={t('header.notification')}
      className={isAnimating ? "trigger-animate" : ""}
      data-track-label
      dataTestId="header-icon-notification"
      onAnimationEnd={() => { setIsAnimating(false); }}
    />)
  };

  const IconButtonWithBadge = withBadge(IconButtonComponent, {
    children: count > 99 ? '99+' : count,
    position: BADGE_POSITIONS.RIGHT,
    badgeColor: unreadCount > 0 ? '#EB0C00' : '#4D4D4D'
  });

  return (
    <div>
      {count > 0 && <IconButtonWithBadge></IconButtonWithBadge>}
      {count === 0 && <IconButtonComponent></IconButtonComponent>}
    </div>
  );
};

export default IconNotificationButton;